// Trailing-edge debounce: every call re-arms the timer, and `wait` ms after
// the last call `fn` runs once with the latest call's arguments. No leading
// invocation, no return-value plumbing — `fn`'s result is discarded, so an
// async `fn` must handle its own rejections. flush() runs a pending
// invocation immediately and disarms its timer; with nothing pending it is a
// no-op.
export function debounce<Args extends unknown[]>(
  fn: (...args: Args) => unknown,
  wait: number,
): { (...args: Args): void; flush: () => void } {
  let pending: { args: Args; timer: ReturnType<typeof setTimeout> } | null =
    null;
  const invoke = (): void => {
    if (pending === null) return;
    const { args, timer } = pending;
    pending = null;
    clearTimeout(timer);
    fn(...args);
  };
  return Object.assign(
    (...args: Args): void => {
      if (pending !== null) clearTimeout(pending.timer);
      pending = { args, timer: setTimeout(invoke, wait) };
    },
    { flush: invoke },
  );
}
